import { render, staticRenderFns } from "./WorkSearch.vue?vue&type=template&id=96f268b8&scoped=true&"
import script from "./WorkSearch.vue?vue&type=script&lang=js&"
export * from "./WorkSearch.vue?vue&type=script&lang=js&"
import style0 from "./WorkSearch.vue?vue&type=style&index=0&id=96f268b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f268b8",
  null
  
)

export default component.exports